/**
 * Mainbeauty — thông báo đăng ký chung: modal thành công + toast lỗi, nghe qua sự kiện DOM.
 */
(function () {
  "use strict";

  var $ = window.jQuery;
  if (!$) return;
  var hasBS = !!($.fn && $.fn.modal); // thiếu Bootstrap JS thì hạ xuống toggle class

  var $modal, $title, $desc, $toastHost;

  function showModal(opts) {
    if (!$modal || !$modal.length) return;
    opts = opts || {};
    if (opts.title) $title.text(opts.title);
    if (opts.message) $desc.text(opts.message);
    if (hasBS) {
      $modal.modal("show");
    } else {
      $modal.addClass("show").css("display", "block");
    }
  }

  function showToast(message, type) {
    if (!$toastHost || !$toastHost.length) return;
    var $toast = $(
      '<div class="toast pi-toast pi-toast--' + (type || "error") + '"' +
        ' role="alert" aria-live="assertive" aria-atomic="true" data-delay="5000">' +
        '<div class="toast-body pi-toast__body"></div>' +
        "</div>"
    );
    $toast.find(".pi-toast__body").text(message);
    $toastHost.append($toast);

    if (hasBS) {
      $toast.on("hidden.bs.toast", function () {
        $toast.remove();
      });
      $toast.toast("show");
    } else {
      $toast.addClass("show");
      setTimeout(function () {
        $toast.remove();
      }, 5000);
    }
  }

  window.piNotify = {
    success: function (message, title) {
      showModal({ message: message, title: title });
    },
    error: function (message) {
      showToast(message, "error");
    },
  };

  $(function () {
    $modal = $("[data-pi-modal]");
    $title = $("[data-pi-modal-title]");
    $desc = $("[data-pi-modal-desc]");
    $toastHost = $("[data-pi-toasts]");

    // Thành công — plugin Leads phát sau khi gửi xong.
    document.addEventListener("pi:lead", function (e) {
      var detail = (e && e.detail) || {};
      var msg =
        (detail.response && detail.response.message) ||
        "Chúng tôi đã nhận thông tin của bạn.";
      showModal({ message: msg });
    });

    // Thất bại — plugin phát khi lỗi validate hoặc lỗi mạng.
    document.addEventListener("pi:lead-error", function (e) {
      var detail = (e && e.detail) || {};
      showToast(detail.message || "Không gửi được, vui lòng thử lại.", "error");
    });
  });
})();
